module.exports = __webpack_public_path__ + "img/1.7b3bb0ff.png";